import React from 'react';
import Navbar from '../../components/navbar';
import FormularioEditarColaborador from '../../components2/formularioEditarColaborador';
function EditarColaborador() {
    return (
        <FormularioEditarColaborador />
    )
}

export default EditarColaborador;